import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api-client';
import { usoSchema } from './uso-schemas';

// Uso da frota de agentes (admin) — volume, tokens e custo por agente/modelo.
export function useUso() {
  return useQuery({
    queryKey: ['agentes', 'uso'] as const,
    queryFn: ({ signal }) => api('/api/v2/agentes/uso', { schema: usoSchema, signal }),
    staleTime: 60_000,
    refetchInterval: 5 * 60_000,
  });
}
